import { makeStyles } from '@eagleview/ev-comp-library';

const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: theme.evPalette.nickel[100], // To be changed from 100 to 500 when color is added to theme
    color: theme.evPalette.charcoal[900],
    width: theme.spacing(38),
    height: theme.spacing(7),
    borderRadius: theme.spacing(0.5),
  },
  container: {
    textAlign: 'center',
    borderRadius: theme.spacing(0.5),
    paddingBottom: theme.spacing(4),
    minWidth: theme.spacing(100),
  },
  box: {
    display: 'inline-flex',
  },
  avatar: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  dialogContent: {
    paddingBottom: theme.spacing(4),
    marginTop: theme.spacing(1.5),
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
  },
  companyName: {
    marginTop: theme.spacing(1),
    ...theme.typography['body--condensed'],
  },
  label: {
    fontSize: theme.spacing(1.75),
    color: theme.evPalette.charcoal[600],
    paddingBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: theme.spacing(2.25),
    color: theme.evPalette.charcoal[800],
    paddingBottom: theme.spacing(1.5),
  },
  detailsContainer: {
    flexGrow: 1,
    width: '100%',
    textAlign: 'left',
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(3.5),
  },
  field: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
